// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.trix-button--icon-attach {\n    display: none !important;\n}\n.trix-button-group--file-tools {\n    display: none !important;\n}\n.trix-content {\n    min-height: 12em !important;\n}\n", ""]);
// Exports
module.exports = exports;
